module.exports = __webpack_public_path__ + "img/step2.9c4b20b4.png";